// extracted by mini-css-extract-plugin
export default {"ipad_layout":"index_ipad_layout_ecZqN","layout":"index_layout_X7KPg"};